import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
// CSS
import '../assets/css/product-card.css'
// Icons
import CartIcon from '../assets/icons/cart.png'
import CheckmarkIcon from '../assets/icons/checkmark.png'
import QuickView from './QuickView'

export default function ProductCard(props) {
  const [ hoverImage, setHoverImage ] = useState(require("../assets/images/product-hover.png"));
  const [over, setOver] = useState(false);

  for (var i = 1; i <= props.rating; i++) {
    document.querySelectorAll('.product_card_id_'+props.productId+ '.rating span:nth-child('+i+')').forEach((item) => {
      item.classList.add('checked')
    });
  }

  return (
    <>
    
    {
    props.card === 1?
    <div className={'product_card_1 product_card_id_'+props.productId}>
      <div className='product_card_wrapper'>
        <div className='thumbnail' onMouseOver={() => setOver(true)} onMouseOut={() => setOver(false)}>
          <Link to={'/product/'+props.productId}>
            <img src={over? hoverImage : props.thumbnail} alt='product' />
          </Link>
          <div className='actions'>
            <button><img src={CartIcon} /></button>
            <button><img src={CheckmarkIcon} /></button>
          </div>
          <div className='labels'>
            {
              props.hotDeal === true?
              <div className='card'>HOT</div>
              :
              <></>
            }
            {
              props.discount === '0%' ?
              <></>
              :
              <div className='card'>{props.discount}</div>
            }
          </div>
          <button className='quick_view_btn' onClick={() => {props.setShowQuickView(true)}}>Quick View</button>
        </div>
        <div className='details'>
          <div className='category'>
            {
              props.category.map((item, index) => {
                return (
                  <>
                  {
                    props.category.length === index + 1?
                    <Link to={'/prdocuts?category='+item.link} key='index'>{item.name}</Link>
                    :
                    <React.Fragment key={index}>
                      <Link to={'/prdocuts?category='+item.link}>{item.name}</Link>
                      <span>,</span>
                    </React.Fragment>
                  }
                  </>
                )
              })
            }
          </div>
          <Link to={'/product/'+props.productId} className='product_title'>{props.title}</Link>
          <div className='rating'>
            <span className='fas fa-star'></span>
            <span className='fas fa-star'></span>
            <span className='fas fa-star'></span>
            <span className='fas fa-star'></span>
            <span className='fas fa-star'></span>
          </div>
          <div className='price'>
            <div className='discount_price'><i className='currency_sign'>$</i><span>{props.realPrice}</span></div>
            <div className='real_price'><i className='currency_sign'>$</i><span>{props.discountPrice}</span></div>
          </div>
        </div>
      </div>
    </div>
    : props.card === 2?
    <div className={'product_card_2 product_card_id_'+props.productId} onMouseOver={() => setOver(true)}
    onMouseOut={() => setOver(false)}>
      <Link to='/product' className='thumbnail select_n'>
        <img src={over? hoverImage : props.thumbnail} alt='product' />
      </Link>
      <div className='details'>
        <div className='top'>
          <Link to='/product' className='product_title'>{props.title}</Link>
          <div className='rating'>
            <span className='fas fa-star'></span>
            <span className='fas fa-star'></span>
            <span className='fas fa-star'></span>
            <span className='fas fa-star'></span>
            <span className='fas fa-star'></span>
          </div>
        </div>
        <div className='price'>
          <div className='real_price'><span className='currency_sign'>$</span> {props.realPrice}</div>
          <div className='discount_price'><span className='currency_sign'>$</span> {props.discountPrice}</div>
        </div>
      </div>
    </div>
    :
    <div className={'product_card_1 product_card_id_'+props.productId}>
      <div className='product_card_wrapper'>
        <div className='thumbnail' onMouseOver={() => setOver(true)} onMouseOut={() => setOver(false)}>
          <Link to={'/product/'+props.productId}>
            <img src={over? hoverImage : props.thumbnail} alt='product' />
          </Link>
          <div className='actions'>
            <button><img src={CartIcon} /></button>
            <button><img src={CheckmarkIcon} /></button>
          </div>
          <div className='labels'>
            {
              props.hotDeal === true?
              <div className='card'>HOT</div>
              :
              <></>
            }
            {
              props.discount === '0%' ?
              <></>
              :
              <div className='card'>{props.discount}</div>
            }
          </div>
          <button className='quick_view_btn' onClick={() => {props.setShowQuickView(true)}}>QUICK VIEW</button>
        </div>
        
        <div className='details'>
          <div className='category'>
            {
              props.category.map((item, index) => {
                return (
                  <>
                  {
                    props.category.length === index + 1?
                    <Link to={'/prdocuts?category='+item.link}>{item.name}</Link>
                    :
                    <>
                      <Link to={'/prdocuts?category='+item.link}>{item.name}</Link>
                      <span>,</span>
                    </>
                  }
                  </>
                )
              })
            }
          </div>
          <Link to={'/product/'+props.productId} className='product_title'>{props.title}</Link>
          <div className='rating'>
            <span className='fas fa-star'></span>
            <span className='fas fa-star'></span>
            <span className='fas fa-star'></span>
            <span className='fas fa-star'></span>
            <span className='fas fa-star'></span>
          </div>
          <div className='price'>
            <div className='real_price'><span className='currency_sign'>$</span> {props.realPrice}</div>
            <div className='discount_price'><span className='currency_sign'>$</span> {props.discountPrice}</div>
          </div>
        </div>
      </div>
    </div>
   }
    </>
  )
}
